/**
 * "What's new" notes — the client's types (server: routes/whatsNew.ts).
 * A note is a title and up to six pictures with one plain line each. Sending
 * gives each person a copy in Tasks that they read and close with Got it.
 */
export const WHATS_NEW_PICS = [
    "truck",
    "check",
    "lock",
    "phone",
    "calendar",
    "camera",
    "wrench",
    "clipboard",
    "alert",
    "star",
    "map",
    "clock",
    "money",
    "person",
] as const;
export type WhatsNewPic = (typeof WHATS_NEW_PICS)[number];

export const WHATS_NEW_MAX_WORDS = 20;
export const WHATS_NEW_MAX_STEPS = 6;

export interface NoteStep {
    pic: WhatsNewPic;
    line: string;
}

export type RecipientState = "got_it" | "opened" | "not_yet";

export interface NoteRecipient {
    userId: string;
    name: string;
    state: RecipientState;
    at: string | null;
    taskId: string | null;
}

export interface PlainWordsProblemDto {
    rule: string;
    field: string;
    line: number;
    found: string;
    message: string;
}

export interface WhatsNewNote {
    id: string;
    title: string;
    steps: NoteStep[];
    status: "draft" | "sent";
    draftedBy: "person" | "claude";
    createdByName: string | null;
    createdAt: string;
    sentAt: string | null;
    sentByName: string | null;
    recipients: NoteRecipient[];
    counts: { total: number; gotIt: number; opened: number; notYet: number };
    problems: PlainWordsProblemDto[];
}

/** What a recipient sees. */
export interface RecipientNote {
    taskId: string;
    noteId: string;
    title: string;
    steps: NoteStep[];
    senderName: string | null;
    sentAt: string | null;
    gotIt: boolean;
}

/** "From Corbin · today" */
export function fromLine(n: Pick<RecipientNote, "senderName" | "sentAt">, now = new Date()): string {
    const who = n.senderName?.split(" ")[0] ?? "the office";
    if (!n.sentAt) return `From ${who}`;
    const d = new Date(n.sentAt);
    const same = d.toDateString() === now.toDateString();
    const when = same ? "today" : d.toLocaleDateString("en-US", { month: "short", day: "numeric" });
    return `From ${who} · ${when}`;
}
